module.exports = __webpack_public_path__ + "static/media/print_24px.14475662.svg";